import { HandlesIcon, styled, css } from 'canoe';
import React from 'react';

import { useEditor } from 'craft/hooks';

const Icon = styled(HandlesIcon)`
  ${({ theme }) => css`
    svg {
      width: ${theme.spaces.xs};
      cursor: move;
      &:hover {
        cursor: move;
      }
    }
  `}
`;

interface DragNodeProps {
  nodeId: string;
}
export const DragNode: React.FC<DragNodeProps> = ({ nodeId }: DragNodeProps) => {
  const { connectors } = useEditor();
  return (
    <div
      ref={(ref: HTMLDivElement) => {
        connectors.drag(ref, nodeId);
      }}
      draggable
    >
      <Icon color="White" mr="xs" />
    </div>
  );
};
